import { render, staticRenderFns } from "./OpportunitiesFilters.vue?vue&type=template&id=67446ae4"
import script from "./OpportunitiesFilters.vue?vue&type=script&lang=js"
export * from "./OpportunitiesFilters.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesFilters.vue?vue&type=style&index=0&id=67446ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports